import {Directive, Input, OnDestroy, TemplateRef, ViewContainerRef} from '@angular/core';
import {IfAuthorizedAbstractDirective} from './if-authorized-abstract.directive';
import {UtilisateurCourantService} from '../../../services/utilisateurs/utilisateur-courant.service';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[ifAuthorizedEdition]',
})
export class IfAuthorizedEditionDirective extends IfAuthorizedAbstractDirective implements OnDestroy {
  constructor(
    viewContainerRef: ViewContainerRef,
    templateRef: TemplateRef<any>,
    utilisateurCourantService: UtilisateurCourantService,
  ) {
    super(viewContainerRef, templateRef, utilisateurCourantService);
    this.forEdition();
  }

  @Input() set ifAuthorizedEditionElse(value: TemplateRef<any>) {
    this.elseTemplate = value;
  }

  ngOnDestroy(): void {
    this.unsubscribeAll();
  }

  @Input() set ifAuthorizedEdition(value: string | number) {
    this.fonctionLogicielle = value;
  }
}
